import { compact } from '../../../../helpers/compact';
import { toImage, toLink, toRichText, toText } from '../../fields';
import {
  HeaderSlice,
  LaPosteEn4Type,
} from '../../../../types/LaPosteEn4/slice';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const headerSlice = (data: Record<string, any>): HeaderSlice | undefined => {
  const image = toImage(data.primary?.image);
  const description = toRichText(data.primary?.description);
  if (!image || !description) {
    return undefined;
  }

  return compact({
    type: LaPosteEn4Type.HEADER,
    image,
    description,
    ctaLabel: toText(data.primary?.ctaLabel),
    ctaLink: toLink(data.primary?.ctaLink),
  });
};

export default headerSlice;
